import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import { Stars } from "@/components/Badges";
import { CheckCircle2 } from "lucide-react";

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  useEffect(() => { api.get("/reviews/recent").then((r) => setReviews(r.data.reviews)).catch(() => {}); }, []);

  const avg = reviews.length ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1) : "5.0";

  return (
    <Layout>
      <div className="hero-gradient grain text-white">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 py-14 text-center">
          <h1 className="font-display text-5xl font-extrabold">Loved by homeowners</h1>
          <div className="mt-4 flex items-center justify-center gap-2">
            <Stars rating={Number(avg)} className="scale-125" />
            <span className="text-white/60">from {reviews.length}+ verified reviews</span>
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12 columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
        {reviews.map((r) => (
          <div key={r.review_id} className="break-inside-avoid bg-white border border-border rounded-2xl p-6">
            <Stars rating={r.rating} />
            <p className="text-lawn-ink/80 mt-3 leading-relaxed">"{r.text}"</p>
            <div className="mt-4 flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-lawn-light flex items-center justify-center text-lawn-dark font-bold text-sm">{r.customer_name?.[0]}</div>
              <div>
                <p className="text-sm font-semibold text-lawn-ink">{r.customer_name}</p>
                {r.verified && <span className="text-[11px] text-lawn flex items-center gap-1"><CheckCircle2 className="w-3 h-3" /> Verified booking</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Layout>
  );
}
